import { render, staticRenderFns } from "./ExplanationButton.vue?vue&type=template&id=ea6bf366&"
import script from "./ExplanationButton.vue?vue&type=script&lang=js&"
export * from "./ExplanationButton.vue?vue&type=script&lang=js&"
import style0 from "./explanation-button.scss?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports